<template>
  <div>
    <b-loading :is-full-page="true" :active="loading"></b-loading>
    <div class="container" v-if="!loading">
      <div class="section">
        <div class="columns is-vcentered">
          <div class="column is-2 is-offset-2">
            <img :src="`${event.imgUrl}`" style="width: 150px" />
          </div>
          <div class="column is-6">
            <h1 class="title">{{ event.eventname }}</h1>
          </div>
        </div>
      </div>
      <div class="columns is-vcentered">
        <div class="column is-8 is-offset-2">
          <div class="flex-card light-bordered light-raised">
            <div class="card-body">
              <div class="has-text-centered has-margin-bottom-30">
                <h2 class="title">Manage Your Team</h2>
              </div>
              <div class="columns">
                <div class="column">
                  <p><strong>Team Name: </strong> {{ entry.teamname }}</p>
                </div>
                <div class="column">
                  <p><strong>Category: </strong> {{ entry.category }}</p>
                </div>
              </div>

              <ul class="has-margin-bottom-30">
                <li v-if="event.config && event.config.teamsize">
                  Maximum {{ event.config.teamsize }} per team
                </li>
                <li>
                  Make sure all your team member's account is linked and
                  waiver's accepted.
                </li>
                <li v-if="disableChange" class="is-danger">
                  <strong
                    >IMPORTANT: You're not allowed to make any more
                    changes.</strong
                  >
                </li>
              </ul>

              <b-table
                :data="members"
                :bordered="false"
                :striped="true"
                :narrowed="true"
                :hoverable="true"
                :loading="loading"
                :mobile-cards="true"
                class="has-margin-bottom-30"
              >
                <template slot-scope="props">
                  <b-table-column field="name" label="Name">
                    <div v-if="props.row.dependant">
                      <div style="color: #aaa; font-size: 0.8em">
                        {{ props.row.email }}
                      </div>
                      <div
                        style="
                          color: #ccc;
                          font-size: 0.8em;
                          text-transform: uppercase;
                        "
                      >
                        {{ props.row.dependant.gender }}
                      </div>
                    </div>
                    <div v-else>
                      {{ props.row.firstname }} {{ props.row.surname }}
                      <div style="color: #aaa; font-size: 0.8em">
                        {{ props.row.email }}
                      </div>
                      <div
                        style="
                          color: #ccc;
                          font-size: 0.8em;
                          text-transform: uppercase;
                        "
                      >
                        {{ props.row.gender }}
                      </div>
                    </div>
                  </b-table-column>

                  <b-table-column label="Account Linked" centered>
                    <b-icon
                      v-if="props.row.user"
                      class="text-success"
                      icon="check"
                    ></b-icon>
                    <b-icon
                      class="text-danger"
                      v-if="!props.row.user"
                      icon="close"
                    ></b-icon>
                  </b-table-column>

                  <b-table-column label="Waiver Accepted" centered>
                    <b-icon
                      class="text-success"
                      v-if="props.row.acceptwaiver"
                      icon="check"
                    ></b-icon>
                    <b-icon
                      class="text-danger"
                      v-if="!props.row.acceptwaiver"
                      icon="close"
                    ></b-icon>
                  </b-table-column>

                  <b-table-column
                    label="Judge"
                    centered
                    v-if="event.config.entryjudge"
                  >
                    <b-icon
                      class="text-success"
                      v-if="props.row.meta && props.row.meta.entryjudge"
                      icon="check"
                    ></b-icon>
                    <b-icon
                      class="text-danger"
                      v-if="
                        !props.row.meta ||
                        (props.row.meta && !props.row.meta.entryjudge)
                      "
                      icon="close"
                    ></b-icon>
                  </b-table-column>

                  <b-table-column
                    label="T-Shirt Size Set"
                    centered
                    v-if="event.config && !event.config.hideshirtoption"
                  >
                    <b-icon
                      class="text-success"
                      v-if="props.row.user && props.row.user.tshirtsize"
                      icon="check"
                    ></b-icon>
                    <b-icon
                      class="text-danger"
                      v-if="
                        !props.row.user ||
                        (props.row.user && !props.row.user.tshirtsize)
                      "
                      icon="close"
                    ></b-icon>
                  </b-table-column>

                  <b-table-column label="">
                    <b-button
                      type="is-danger"
                      v-if="!event.config.lockchanges"
                      @click="removeMember(props.row)"
                      >Remove</b-button
                    >
                  </b-table-column>
                </template>

                <template slot="empty">
                  <section class="section">
                    <div
                      v-if="!event.config.lockchanges"
                      class="content has-text-grey has-text-centered"
                    >
                      <p>
                        <b-icon icon="emoticon-sad" size="is-large"> </b-icon>
                      </p>
                      <p>
                        No team members yet.<br />
                        <a href="" @click.prevent="addMember"
                          >Invite team member</a
                        >
                      </p>
                    </div>
                  </section>
                </template>
              </b-table>

              <div class="container is-widescreen has-margin-bottom-30">
                <div class="notification">
                  <div class="has-text-centered"><b-icon icon="help" /></div>
                  <strong>Column explanations: </strong>
                  <div class="has-margin-bottom-10">
                    <strong>Account Linked: </strong> The team member must be
                    registered with the same email address as you've invited
                    them, then it will show as linked.
                  </div>
                  <div class="has-margin-bottom-10">
                    <strong>Waiver Accepted: </strong> The team member needs to
                    login and sign the waiver. The
                    <strong>Finalize Entry</strong> button will be available
                    under the event, once the team member has been linked
                    successfully!
                  </div>
                  <div class="has-margin-bottom-10">
                    <strong>T-Shirt Size Set: </strong> The team member can set
                    their shirt size under <strong>Edit Profile</strong> once
                    they've logged in.
                  </div>
                </div>
              </div>

              <ul>
                <li v-if="members.length === 0 && !disableChange">
                  It is only yourself in the team.
                  <!-- <a href="" ng-click="addMember()">Add</a> some more members. -->
                </li>
                <li v-if="members.length > 0">
                  {{ members.length + 1 }} team members in your team including
                  yourself. <br /><strong
                    >Add your team members ONLY, do not add yourself as you're
                    already part of the team</strong
                  >
                </li>
              </ul>
              <div class="has-text-centered has-margin-top-30" v-if="!teamFull">
                <button class="button is-primary" @click="addMember">
                  Invite Team Member
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ConfirmModal
      ref="deleteModal"
      title="Confirm?"
      message="Are you sure you want to remove the team member?"
    />
    <b-modal
      :active.sync="showAddMemberModal"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <ValidationObserver v-slot="{ passes }">
        <form @submit.prevent="passes(submit)">
          <div class="modal-card" style="width: auto">
            <header class="modal-card-head">
              <p class="modal-card-title">Add Team Member</p>
            </header>
            <section class="modal-card-body">
              <p class="has-margin-bottom-15">
                NOTE: Please do not use your own email address when adding
                friends, because they will need to use their own email address.
                If you have done so, please remove the team member and add them
                again.
              </p>
              <p class="has-margin-bottom-15">
                If they've signed up with a different email address, please
                re-add them with the correct email address.
              </p>
              <div class="columns is-multiline">
                <div class="column is-6-desktop">
                  <div class="control">
                    <BaseInput
                      label="Firstname"
                      v-model="member.firstname"
                      rules="required"
                    />
                  </div>
                </div>
                <div class="column is-6-desktop">
                  <div class="control">
                    <BaseInput
                      label="Surname"
                      v-model="member.surname"
                      rules="required"
                    />
                  </div>
                </div>
                <div class="column is-6-desktop">
                  <div class="control">
                    <BaseInput
                      label="Email Address"
                      v-model="member.email"
                      rules="required|email"
                    />
                  </div>
                </div>
                <div class="column is-6-desktop">
                  <div class="control">
                    <GenderSelect
                      label="Gender"
                      v-model="member.gender"
                      rules="required"
                    />
                  </div>
                </div>
                <div class="column is-6-desktop" v-if="event.config.entryjudge">
                  <b-field class="m-t-sm">
                    <b-checkbox v-model="member.meta.entryjudge">
                      Team Member will be the judge
                    </b-checkbox>
                  </b-field>
                </div>
              </div>
            </section>
            <footer class="modal-card-foot">
              <button
                class="button"
                type="button"
                @click="showAddMemberModal = false"
              >
                Cancel
              </button>
              <b-button
                class="is-primary"
                @click="passes(submit)"
                :loading="saving"
                >Add</b-button
              >
            </footer>
          </div>
        </form>
      </ValidationObserver>
    </b-modal>
  </div>
</template>

<script>
import ConfirmModal from "@/components/ConfirmModal";
import BaseInput from "@/components/BaseInput";
import GenderSelect from "@/components/GenderSelect";
import filters from "@/filters";
import TeamMemberApi from "@/api/team-member";
import EventEntryApi from "@/api/event-entry";
export default {
  components: {
    ConfirmModal,
    BaseInput,
    GenderSelect,
  },
  mixins: [filters],
  data() {
    return {
      loading: true,
      member: {},
      entry: {},
      event: {},
      members: [],
      saving: false,
      disableChange: false,
      showAddMemberModal: false,
    };
  },
  computed: {
    teamFull() {
      let limits = [];
      let full = false;
      if (this.event.config && this.event.config.teamrules) {
        this.event.config.teamrules.forEach((item) => {
          item.id = this.event._id;
        });
        limits = this.event.config.teamrules;
      }

      var rule = limits.find((item) => item.id === this.event._id);
      if (rule) {
        if (rule.categories) {
          rule = rule.categories.find(
            (item) => item.name === this.entry.category
          );
          if (rule) {
            full = this.checkLimits(rule.max);
          }
        } else {
          full = this.checkLimits(rule.max);
        }
      } else if (this.event.config && this.event.config.teamsize) {
        full = this.checkLimits(this.event.config.teamsize - 1);
      }
      return full;
    },
  },
  async created() {
    this.entry = await EventEntryApi.getEventEntry(this.$route.params.id);
    if (this.entry) {
      this.event = this.entry.event;
    }
    await this.getMembers();
    this.loading = false;
  },
  methods: {
    checkLimits(max) {
      return this.members.length >= max;
    },
    async getMembers() {
      this.members = await TeamMemberApi.membersForEntry(this.$route.params.id);
    },
    removeMember(member) {
      let selectedMemberId = member._id;
      return this.$refs.deleteModal.show().then(() => {
        return TeamMemberApi.removeMember(selectedMemberId)
          .then(this.getMembers)
          .then(() => {
            this.$buefy.toast.open({
              message: "Removed team member successfully!",
              position: "is-top",
              type: "is-success",
            });
          });
      });
    },
    addMember() {
      this.member = {
        event: this.event._id,
        evententry: this.entry._id,
        meta: {},
      };
      this.showAddMemberModal = true;
    },
    async submit() {
      this.saving = true;
      try {
        await TeamMemberApi.addMember(this.member);
        await this.getMembers();
        this.showAddMemberModal = false;
        this.saving = false;
        this.$buefy.toast.open({
          message: "Team Member invited successfully!",
          position: "is-top",
          type: "is-success",
        });
      } catch (error) {
        this.saving = false;
        console.log(error);
        this.$buefy.toast.open({
          message: "Error inviting team member. " + error.message,
          position: "is-top",
          type: "is-danger",
        });
      }
    },
  },
};
</script>
